import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fetchProducts } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { ProductImage } from "../components/ProductImage";
import { useDocumentMeta } from "../hooks/use-document-meta";

export default function Gallery() {
  useDocumentMeta({
    title: "Galerie produits — Grossiste frites surgelées & fournisseur fast-food",
    description:
      "Aperçu visuel du catalogue Frites Dorées : frites surgelées, viandes, volailles, sauces restauration rapide, emballages alimentaires professionnels. Sélection grossiste B2B pour la restauration rapide.",
    canonicalPath: "/galerie",
  });
  const [products, setProducts] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProducts().then((p) => setProducts(p.slice(0, 40)));
  }, []);

  // mosaic: alternate aspect ratios
  const aspectClasses = ["aspect-square", "aspect-[3/4]", "aspect-square", "aspect-[4/3]"];

  return (
    <main data-testid="gallery-page" className="bg-[#050505]">
      <PageHeader
        kicker="Galerie — Sélection visuelle"
        title={<>Le catalogue <br /><span className="text-[#FFC300]">en images.</span></>}
        subtitle="Un aperçu visuel des produits signatures Frites Dorées. Chaque image est un produit réellement distribué."
      />
      <section className="px-6 md:px-10 lg:px-14 py-16 lg:py-24">
        <div className="columns-2 md:columns-3 lg:columns-4 xl:columns-5 gap-3 md:gap-4 [column-fill:_balance]">
          {products.map((p, i) => (
            <motion.a
              key={p.id}
              href={`/produit/${p.slug}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: Math.min(i * 0.02, 0.4) }}
              className={`block mb-3 md:mb-4 break-inside-avoid group cursor-pointer`}
              data-testid={`gallery-item-${p.slug}`}
            >
              <div className={`product-frame relative overflow-hidden ${aspectClasses[i % aspectClasses.length]}`}>
                <ProductImage
                  path={p.image}
                  alt={p.name}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-contain p-6 transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-t from-black/80 to-transparent transition-opacity duration-500 flex items-end p-4">
                  <span className="font-display text-sm md:text-base text-white uppercase tracking-tight leading-tight">{p.name}</span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </section>
    </main>
  );
}
